import { Typography } from 'lighthouse';

import { StoreCityBadgeProps } from './models';

import { Location } from 'iconsax-react';

export const StoreCityBadge = ({ cityName, compact = false }: StoreCityBadgeProps) => {
    const name = cityName?.trim();

    if (!name) return null;

    if (compact) {
        return (
            <span className='inline-flex max-w-full items-center gap-1 text-blackMediumEmphasis' title={`شهر فروشگاه: ${name}`}>
                <Location size={14} color='currentColor' className='shrink-0' aria-hidden />
                <Typography variant='caption' component='span' color='blackMediumEmphasis' className='min-w-0 truncate text-xs font-medium leading-5'>
                    <span className='sr-only'>شهر فروشگاه: </span>
                    {name}
                </Typography>
            </span>
        );
    }

    return (
        <span
            className='inline-flex max-w-full items-center gap-1.5 self-start rounded-lg border border-solid border-primary/15 bg-primary/5 px-2.5
                py-1.5 text-primary'>
            <Location size={16} color='currentColor' variant='Bold' className='shrink-0' aria-hidden />
            <Typography variant='caption' component='span' color='primary' className='min-w-0 break-words leading-5'>
                <span className='font-normal'>شهر فروشگاه: </span>
                <span className='font-bold'>{name}</span>
            </Typography>
        </span>
    );
};
